/**
 * TabSection.jsx — Phase 147 (Dashboard Cleanup). Tab-visibility wrapper.
 * Keeps DOM mounted (display:none via "hidden") so widgets keep their own
 * internal state when switching Dashboard tabs.
 */
import React from "react";

export default function TabSection({ activeTab, id, children }) {
  return (
    <div className={activeTab === id ? "" : "hidden"} data-testid={`tab-section-${id}`}>{children}</div>
  );
}
